import React, { useState } from 'react';
import { Row, Container, Table } from 'reactstrap';
import KaAlert from '../Common/KaAlert';
import useDisplayMessage from '../Common/useDisplayMessage';
import { EditSite } from './EditSite';
import SiteDto from '../Common/dtos/RegisteredSiteDto';
import SiteUpsertDto from '../Common/dtos/SiteUpsertDto';
import BoldButton from '../Common/BoldButton';
import QueryView from '../Common/QueryView';
import useGetAdminSites from '../Requests/useGetAdminSites';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';

const SitePage = () => {
  const business = useSelectedBusiness();
  const getSites = useGetAdminSites();
  const displayMessage = useDisplayMessage();
  const [editingSite, setEditingSite] = useState<SiteDto | null>(null);

  const editSuccess = (s: SiteUpsertDto) => {
    displayMessage.success(`Site ${s.name} updated`);
    getSites.query();
    setEditingSite(null);
  }

  const unusedSites = business.siteAllowance - (getSites.data?.length ?? 0);

  return <QueryView
    query={getSites}
    renderData={sites =>
        <Container>
          {editingSite &&
            <EditSite
              onSuccess={editSuccess}
              initialSite={editingSite}
              onHide={() => setEditingSite(null)} />
          }
          <Row className="mb-2">
            <h2 className="col-auto my-auto ka-blue">Sites</h2>
            <label className="col-auto my-auto" title="unusedSites">({unusedSites} Remaining)</label>
          </Row>
          <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
          <Table bordered className="preserve-whitespace">
            <thead>
              <tr>
                <th>Name</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sites.sort((a, b) => a.name.localeCompare(b.name)).map(site =>
                <tr key={site.id}>
                  <td>{site.name}</td>
                  <td align="right"><BoldButton className="btn-ghost-secondary" onClick={() => setEditingSite(site)}>Edit</BoldButton></td>
                </tr>
              )}
            </tbody>
          </Table>
        </Container>
      }
    />
}

export { SitePage };
